// Shared Plotly helpers used across Methanol chart components.
/**
 * Builds a Plotly annotation object for an N/A data point.
 * Renders a bold "N/A" label at the bottom of the bar slot.
 *
 * @param date - The x-axis category value (date label) for the slot.
 */
export const buildNaAnnotation = (date) => ({
    font: { color: "#808080", family: "Noto Sans, sans-serif", size: 11 },
    showarrow: false,
    text: "<b>N/A</b>",
    x: date,
    xanchor: "center",
    y: 0,
    yanchor: "bottom"
});
